import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
  Modal,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong, FaPlus } from 'react-icons/fa6';

import { SlCloudUpload } from 'react-icons/sl';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import InfoTooltip from '../InfoTooltip';
import {
  createCategory,
  createCleaner,
  createDoorList,
  createRepairMan,
  createSmartHomeDevice,
  createSmartHomeRoom,
  createSpecialAccesss,
  getAllSmartThingsDevices,
  getBnbList,
  getShellyDevices,
  getSmartHomeRoomByBnB,
  uploadFile,
} from '../../helper/backend_helper';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 1,
};

const CreateSmartHome = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [formData, setFormData] = useState({ profileImage: null });
  const [phoneNumber, setPhoneNumber] = useState('');
  const [deviceName, setDeviceName] = useState('');
  const [bnb, setBnB] = useState([]);
  const [email, setEmail] = useState('');
  const [rooms, setRooms] = useState([]);
  const [room, setRoom] = useState('');
  const [name, setName] = useState('');
  const [italianName, setItalianName] = useState('');
  const [roomBnb, setRoomBnb] = useState([]);
  const [provider, setProvider] = useState('');
  const [deviceType, setDeviceType] = useState('');
  const [minTemp, setMinTemp] = useState(0);
  const [maxTemp, setMaxTemp] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [activeStartDate, setActiveStartDate] = useState(null);
  const [devices, setDevices] = useState([]);
  const [device, setDevice] = useState("");
  const [gpsRange, setGpsRange] = useState(0);
  const handleStartDateChange = (newValue) => {
    setActiveStartDate(newValue); // Update state when date is selected
  };
  const [activeEndDate, setActiveEndDate] = useState(null);
  const handleEndDateChange = (newValue) => {
    setActiveEndDate(newValue); // Update state when date is selected
  };
  const [loading, setLoading] = useState(false);

  const handleChangeRoomBnb = (event) => {
    setRoomBnb(event.target.value);
  };

  const handleChangeDevice = (event) => {
    setDevice(event.target.value);
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const getRooms = async () => {
    try {
      const data = {
        bnb,
      };
      const headers = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await getSmartHomeRoomByBnB(data, headers);
      setRooms(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getRooms();
  }, [bnb]);

  useEffect(() => {
    fetchData();
  }, []);

  const getDevices = async () => {
    try {
      if (provider === 'shelly') {
        const res = await getShellyDevices();
        setDevices(res?.data?.data);
      }
      if (provider === 'smartthings') {
        const res = await getAllSmartThingsDevices();
        setDevices(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDevices();
  }, [provider]);





  const handleSave = async () => {
    try {
      setLoading(true); 
     console.log(device)
      const Categorydata = {
        deviceName,
        bnb,
        room,
        provider,
        smartThingDevice : provider==="smartthings"?device:null,
        shellyDevice:provider==="shelly"?device:null,
        deviceType,
        minTemp:+minTemp,
        maxTemp:+maxTemp,
        activeStartDate:new Date(activeStartDate),
        activeEndDate :new Date(activeEndDate),
        minutes:+minutes,
        gpsRange:+gpsRange,


      };
      console.log(Categorydata);
      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createSmartHomeDevice(Categorydata, Categoryheaders);

      Swal.fire({
        icon: 'success',
        title: 'Device created successfully',
      });
      navigate(-1)
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  const handleCreateRoom = async () => {
    try {
      const Categorydata = {
        name,
        italianName,
        bnb: roomBnb,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createSmartHomeRoom(Categorydata, Categoryheaders);

      setName('');
      setItalianName('');
      setRoomBnb('');
      
      setOpen(false);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <>
      <Helmet>
        <title> create smart home </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Create Smart Home</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '50ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Name <InfoTooltip title="Label for this smart-home device, shown in the control panel (e.g. Living Room Thermostat)." /></FormLabel>
              <TextField
                label="Enter Device Name"
                id="outlined-size-small"
                value={deviceName}
                onChange={(e) => setDeviceName(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack mt={2} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>BnB <InfoTooltip title="The property this device belongs to; controls and schedules apply to that BnB." /></FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
                renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack mt={2} spacing={{ xs: 2, sm: 4 }} direction="row" alignItems="center" justifyContent="start">
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>Rooms <InfoTooltip title="The room within the property where this device is located; use the + button to add a new room." /></FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                value={room} // This will be an array
                onChange={(e) => setRoom(e.target.value)}
                onOpen={() => getRooms()}
              >
                {rooms?.map((user) => (
                  <MenuItem key={user._id} value={user._id}>
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Tooltip title="Create Room">
              <IconButton onClick={handleOpen}>
                <FaPlus color="#1E3A5F" size={24} />
              </IconButton>
            </Tooltip>
          </Stack>

          <Stack mt={2}>
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>Select Provider <InfoTooltip title="Smart-home platform that controls this device (Shelly or SmartThings); determines which devices are available below." /></FormLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={provider}
                onChange={(e) => setProvider(e.target.value)}
              >
                <MenuItem value="shelly">Shelly</MenuItem>
                <MenuItem value="smartthings">Smart Things</MenuItem>
              </Select>
            </FormControl>
          </Stack>
          <Stack mt={2}>
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>Devices <InfoTooltip title="The physical device from the selected provider account to link to this entry." /></FormLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={device}
                onChange={handleChangeDevice}
              >
                {devices?.map((user) => (
                  <MenuItem key={user._id} value={user._id}>
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack mt={2}>
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>Select Device Type <InfoTooltip title="What the device does (blinds, dimmable light, on/off light, or thermostat); thermostat shows extra settings." /></FormLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={deviceType}
                onChange={(e) => setDeviceType(e.target.value)}
              >
                <MenuItem value="blinds">Blinds</MenuItem>
                <MenuItem value="dimmable light">Dimmable Light</MenuItem>
                <MenuItem value="on/off light">On/Off Light</MenuItem>
                <MenuItem value="thermostat">Thermostat</MenuItem>
              </Select>
            </FormControl>
          </Stack>
          {deviceType === 'thermostat' && (
            <>
              <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
                <Stack>
                  <FormLabel sx={{ mb: 1 }}>Min Temp <InfoTooltip title="Lowest temperature (°C) guests are allowed to set on this thermostat." /></FormLabel>
                  <TextField
                    type="number"
                    label="Enter Min Temp"
                    id="outlined-size-small"
                    value={minTemp}
                    onChange={(e) => setMinTemp(e.target.value)}
                  />
                </Stack>
                <Stack>
                  <FormLabel sx={{ mb: 1 }}>Max Temp <InfoTooltip title="Highest temperature (°C) guests are allowed to set on this thermostat." /></FormLabel>
                  <TextField
                    type="number"
                    label="Enter Max Temp"
                    id="outlined-size-small"
                    value={maxTemp}
                    onChange={(e) => setMaxTemp(e.target.value)}
                  />
                </Stack>
              </Stack>

              <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
                <DatePicker
                  label="Active Start Date"
                  value={activeStartDate}
                  onChange={handleStartDateChange}
                  renderInput={(params) => <TextField {...params} />}
                />
                <DatePicker
                  label="Active End Date"
                  value={activeEndDate}
                  onChange={handleEndDateChange}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>

              <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
                <Stack>
                  <FormLabel sx={{ mb: 1 }}>Automatically Turn Off (minutes) <InfoTooltip title="Minutes of inactivity after which the device shuts off automatically to save energy; 0 disables it." /></FormLabel>
                  <TextField
                    type="number"
                    label="Automatically Turn Off (minutes)"
                    id="outlined-size-small"
                    value={minutes}
                    onChange={(e) => setMinutes(e.target.value)}
                  />
                </Stack>

                <Stack>
                  <FormLabel sx={{ mb: 1 }}>Gps Range (meters) <InfoTooltip title="Distance in meters within which a guest must be for the device to activate based on their location." /></FormLabel>
                  <TextField
                    type="number"
                    label="Gps Range (meters)"
                    id="outlined-size-small"
                    value={gpsRange}
                    onChange={(e) => setGpsRange(e.target.value)}
                  />
                </Stack>
              </Stack>
            </>
          )}
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Create Room
          </Typography>

          <Stack mt={2}>
            <FormControl fullWidth>
              <FormLabel sx={{ mb: 1 }}>BNB <InfoTooltip title="The properties this new room belongs to." /></FormLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={roomBnb}
                onChange={handleChangeRoomBnb}
                size="small"
                multiple
                renderValue={(selected) => selected.join(', ')}
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                  <Checkbox checked={roomBnb.indexOf(user.BnBShortName) > -1} />
                  {user.BnBShortName}
                </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <TextField
            size="small"
            id="standard-name"
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            margin="normal"
            fullWidth
            required
            autoFocus
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            size="small"
            id="standard-setItalianName"
            label="Italian Name"
            value={italianName}
            onChange={(e) => setItalianName(e.target.value)}
            margin="normal"
            fullWidth
            required
            autoFocus
            InputLabelProps={{
              shrink: true,
            }}
          />

          <Button onClick={handleCreateRoom} variant="contained" sx={{ backgroundColor: '#1E3A5F', marginTop: 2 }}>
            Save
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default CreateSmartHome;
